import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  applyClarityCookieConsent,
  hasPdsCookieConsent,
  identifyClarityUser,
  isClarityExcludedPath,
  syncClarityForRoute,
} from '../lib/analytics/clarity'
import { useAuth } from '../hooks/useAuth'

/** Steruje Clarity przy nawigacji SPA: wyłącza /admin, zgoda cookies, identify po logowaniu. */
export function ClarityManager() {
  const { pathname } = useLocation()
  const { user } = useAuth()

  useEffect(() => {
    syncClarityForRoute(pathname)
    if (!isClarityExcludedPath(pathname) && hasPdsCookieConsent()) {
      applyClarityCookieConsent(true)
    }
  }, [pathname])

  useEffect(() => {
    identifyClarityUser(user?.id ?? null, pathname)
  }, [pathname, user?.id])

  return null
}
